module.exports = __webpack_public_path__ + "static/icons/icon-snow-alert--red-480748c75f7fdc4f01e46193ae1537f8.svg";